module.exports = __webpack_public_path__ + "static/checkbox-label-do-ac9ccaa68dcab44f2b6ce82cb1e0de75.png";